export const FETCH_SUBSCRIPTION_PLANS_PENDING = 'FETCH_SUBSCRIPTION_PLANS_PENDING';
export const FETCH_SUBSCRIPTION_PLANS_FAILURE = 'FETCH_SUBSCRIPTION_PLANS_FAILURE';
export const FETCH_SUBSCRIPTION_PLANS_SUCCESS = 'FETCH_SUBSCRIPTION_PLANS_SUCCESS';

const fetchSubscriptionPlansPending = () => ({ type: FETCH_SUBSCRIPTION_PLANS_PENDING });
const fetchSubscriptionPlansFailure = () => ({ type: FETCH_SUBSCRIPTION_PLANS_FAILURE });
const fetchSubscriptionPlansSuccess = plans => ({ type: FETCH_SUBSCRIPTION_PLANS_SUCCESS, plans });

export const fetchSubscriptionPlans = cancelToken => async (dispatch, getState, api) => {
  dispatch(fetchSubscriptionPlansPending());
  try {
    const data = await api({ apiPath: 'subscription-plans', cancelToken });
    dispatch(fetchSubscriptionPlansSuccess(data));
    return data;
  } catch (error) {
    dispatch(fetchSubscriptionPlansFailure());
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/actions/subscriptionPlan.js